// extracted by mini-css-extract-plugin
export default {"root":"render-cell-gray-zeros_root__7KoRA","zero":"render-cell-gray-zeros_zero__H5k+t","placeHolderShimmer":"render-cell-gray-zeros_placeHolderShimmer__sCc2p"};